import { createContext } from "react";
const DefaultMessagesContext = createContext(null);
export {
  DefaultMessagesContext
};
